"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsibleText = exports.Container = void 0;
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.Container = styled_components_1.default.div `
	line-height: 22px;
	font-size: ${({ theme }) => `${theme.baseFontSize}`};
	text-align: center;
	margin: 16px 15px;

	input[type='checkbox'] {
		display: none;
	}

	.toggle-text{
		cursor: pointer;
		color: ${({ theme }) => `${theme.denimBlue}`};
		border-bottom: 1px solid transparent;
		padding-bottom: 4px;

		&:hover {
			border-bottom: ${({ theme }) => `1px solid ${theme.denimBlue}`};
		}
	}

	.toggle:checked + .toggle-text + .collapsible-content {
		max-height: 500px;
	}

	.toggle:checked + .toggle-text .toggle-icon {
		transform: rotate(180deg);
	}

	.toggle-icon {
		margin-left: 15px;
		color: ${({ theme }) => `${theme.denimBlue}`};
		transition: transform .2s ease-out;
	}

	.collapsible-content {
		max-height: 0px;
		overflow: hidden;
		margin: 16px 0;
		-webkit-transition: max-height .35s ease-in-out;
		transition: max-height .35s ease-in-out;

		.collapse-description {
			margin: 0;
			white-space: pre-line;
		}
	}
`;
const CollapsibleText = ({ shortDescription, description }) => {
    return (react_1.default.createElement(exports.Container, null,
        react_1.default.createElement("input", { id: 'collapsible', className: 'toggle', type: 'checkbox' }),
        react_1.default.createElement("label", { htmlFor: 'collapsible', className: 'toggle-text' },
            shortDescription,
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: 'toggle-icon', icon: pro_light_svg_icons_1.faChevronDown })),
        react_1.default.createElement("div", { className: 'collapsible-content' },
            react_1.default.createElement("p", { className: 'collapse-description' }, description))));
};
exports.CollapsibleText = CollapsibleText;
